//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";

export default {
  name: "app-packages-form-modal",

  props: ["visible", "formTitle", "message", "entity"],

  data() {
    return {
      loading: false,
      packageType: "both",
      monthlyPrice: 0,
      monthlyNestedPrice: 0,
      yearlyPrice: 0,
      yearlyNestedPrice: 0,
    };
  },

  computed: {
    ...mapGetters({
      packages: "setting/list/packages",
    }),

    packageTypeOptions() {
      return [
        {
          label: this.i18n("entities.setting.packages.monthly"),
          value: "monthly",
        },
        {
          label: this.i18n("entities.setting.packages.yearly"),
          value: "yearly",
        },
        {
          label: this.i18n("entities.setting.packages.both"),
          value: "both",
        },
      ];
    },

    dialogVisible: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    validatePrice(price) {
      return price >= 0 && !isNaN(price);
    },

    i18n(key, args) {
      return this.$t(key, args);
    },

    async doSubmit() {
      this.loading = true;

      try {
        const db = firebase.firestore();
        const batch = db.batch();

        // Update monthly package
        if (this.packageType === "monthly" || this.packageType === "both") {
          const monthlyRef = db.collection("settings").doc("packageMonthly");
          batch.set(monthlyRef, {
            id: "packageMonthly",
            price: parseFloat(this.monthlyPrice) || 0,
            nestedPrice: parseFloat(this.monthlyNestedPrice) || 0,
            type: "Monthly",
          });
        }

        // Update yearly package
        if (this.packageType === "yearly" || this.packageType === "both") {
          const yearlyRef = db.collection("settings").doc("packageYearly");
          batch.set(yearlyRef, {
            id: "packageYearly",
            price: parseFloat(this.yearlyPrice) || 0,
            nestedPrice: parseFloat(this.yearlyNestedPrice) || 0,
            type: "Yearly",
          });
        }

        await batch.commit();

        this.$q.notify({
          type: "positive",
          message: this.$t("common.updatedMaximumNumber"),
          position: "top",
        });

        this.loading = false;
        this.$emit("success");

        // Refresh packages data and update store
        await this.loadPackages();
        const packagesData = {
          monthly: {
            price: parseFloat(this.monthlyPrice) || 0,
            nestedPrice: parseFloat(this.monthlyNestedPrice) || 0,
            type: "Monthly",
          },
          yearly: {
            price: parseFloat(this.yearlyPrice) || 0,
            nestedPrice: parseFloat(this.yearlyNestedPrice) || 0,
            type: "Yearly",
          },
        };
        this.$store.dispatch("setting/list/setPackages", packagesData);
      } catch (error) {
        console.error("Error saving packages:", error);
        this.$q.notify({
          type: "negative",
          message: this.$t("errors.defaultErrorMessage"),
          position: "top",
        });
        this.loading = false;
      }
    },

    async loadPackages() {
      try {
        const db = firebase.firestore();

        // Load monthly package
        const monthlyDoc = await db
          .collection("settings")
          .doc("packageMonthly")
          .get();
        if (monthlyDoc.exists) {
          const monthlyData = monthlyDoc.data();
          this.monthlyPrice = monthlyData.price || 0;
          this.monthlyNestedPrice = monthlyData.nestedPrice || 0;
          console.log("Loaded monthly package:", monthlyData);
        } else {
          // Create default monthly package if it doesn't exist
          await db.collection("settings").doc("packageMonthly").set({
            id: "packageMonthly",
            price: 300,
            nestedPrice: 400,
            type: "Monthly",
          });
          this.monthlyPrice = 300;
          this.monthlyNestedPrice = 400;
          console.log("Created default monthly package");
        }

        // Load yearly package
        const yearlyDoc = await db
          .collection("settings")
          .doc("packageYearly")
          .get();
        if (yearlyDoc.exists) {
          const yearlyData = yearlyDoc.data();
          this.yearlyPrice = yearlyData.price || 0;
          this.yearlyNestedPrice = yearlyData.nestedPrice || 0;
          console.log("Loaded yearly package:", yearlyData);
        } else {
          // Create default yearly package if it doesn't exist
          await db.collection("settings").doc("packageYearly").set({
            id: "packageYearly",
            price: 1200,
            nestedPrice: 2000,
            type: "Yearly",
          });
          this.yearlyPrice = 1200;
          this.yearlyNestedPrice = 2000;
          console.log("Created default yearly package");
        }
      } catch (error) {
        console.error("Error loading packages:", error);
      }
    },

    doCancel() {
      this.dialogVisible = false;
    },
  },

  async mounted() {
    await this.loadPackages();
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadPackages();
      }
    },
  },
};
